module.exports = __webpack_public_path__ + "media/images/badges/cyclebar/grey/RideClub_Milestones_App_1000-Grey-87ca3789ab8bd5a926629d661ef3267e.png";